import { useCallback, useEffect, useRef, useState } from 'react';

// Avvolge una funzione async per evitare doppi invii: `pending` resta true dal
// primo click alla risposta (successo o errore), e una seconda chiamata a
// `run` mentre e' gia' in corso viene ignorata invece di partire una seconda
// richiesta (es. due click ravvicinati che genererebbero due codici
// attivazione identici). Uso tipico su un bottone:
//
//   const { run, pending } = useAsyncAction(handleSubmit);
//   <button onClick={run} disabled={pending}>{pending ? 'Salvataggio…' : 'Salva'}</button>
export function useAsyncAction(action) {
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);
  const mountedRef = useRef(true);

  useEffect(() => () => { mountedRef.current = false; }, []);

  const run = useCallback((...args) => {
    if (pendingRef.current) return undefined;
    pendingRef.current = true;
    setPending(true);
    return Promise.resolve(action(...args)).finally(() => {
      pendingRef.current = false;
      if (mountedRef.current) setPending(false);
    });
  }, [action]);

  return { run, pending };
}

export default useAsyncAction;
